"use strict";
function mountRecommendations() {
    var recPrev = dq("button.recPrev");
    var recNext = dq("button.recNext");
    var recInner = dq(".recommendationsInner");
    recPrev.addEventListener("click", function () {
        var leftPos = recInner.scrollLeft;
        console.log("scrollleft", leftPos);
        recInner.scrollBy({
            left: -recInner.clientWidth,
            behavior: "smooth",
        });
    });
    recNext.addEventListener("click", function () {
        var leftPos = recInner.scrollLeft;
        console.log("scrollleft", leftPos);
        recInner.scrollBy({
            left: recInner.clientWidth,
            behavior: "smooth",
        });
    });
    recInner.addEventListener("scroll", function (event) { return scrollHandler(event, recNext, recPrev); });
}
var productRecommendationsSection = dq(".recommendations");
var recommendationUrl = productRecommendationsSection.dataset.url;
document.addEventListener("DOMContentLoaded", function () {
    fetch(recommendationUrl)
        .then(function (response) { return response.text(); })
        .then(function (text) {
        var html = document.createElement("div");
        html.innerHTML = text;
        var recommendations = html.querySelector(".recommendations");
        if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
            mountRecommendations();
        }
        if (Currency.cookie) {
            var cookieCurrency = Currency.cookie.read();
            var shopCurrency = "USD";
            Currency.convertAll(shopCurrency, cookieCurrency);
        }
    })
        .catch(function (e) {
        console.error(e);
    });
});
